<template>
  <div class="modal-backdrop pt-4">
    <div class="card maincard col-lg-3 col-md-8 mt-md-4 col-11 mx-auto p-0" :class="{'confirmCard' :displayConfirmationModal}" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0"  v-if="!displayConfirmationModal">
        <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2" id="exampleModalLabel">Report Profile</h5><span class="fontsize10 font-italic black60 proximanova mt-2 ml-2" >This profile is not relevent or offensive</span>          
          <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="line"></div>
        <div class="modal-body borderradius10 bodymodal11 bodymodal12" id="accordion">
          <span class="fontsize14 red proximanova ml-3">{{message}}</span>
          <div class="pl-4 pr-4 pt-2 pb-4">
            <div class="row opacityfont-12 d-flex flex-column">
              <div class="col-12 reportcard1">
                <div class="card-header reportcard11" id="cardheading1" data-toggle="collapse" data-target="#report1" aria-expanded="true" aria-controls="report1">
                  <a class="fontsize16 black60 proximanova-semibold" :class="{'selectedLabel':ReportProfile !== null}">Report Profile/User</a>
                </div>
                <div id="report1" class="collapse" data-parent="#accordion" aria-labelledby="cardheading1">
                  <div>
                    <div class="pl-3 pr-3 pb-3">
                      <div v-for="(reason, index) in reportProfilereasonsList" :key="index">
                        <div class="d-flex mb-3"  @click="clearexceptReportProfile">
                          <input type="radio" :id="'reason'+reason.id" name="reportprofile" :value="reason.id" class="my-auto" v-model="ReportProfile">
                          <div class="d-flex flex-column">
                            <label :for="'reason'+reason.id" class="fontsize14 black proximanova-semibold labels ml-2 my-auto" :class="{'selectedLabel':ReportProfile == reason.id}">{{reason.indexDetailName}}</label>
                            <!-- <span class="font12-opacity80Reg ml-2">Misleading Profile</span> -->
                          </div>
                          <br>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 reportcard1 mt-3" >
                <div class="card-header reportcard11" id="cardheading2" data-toggle="collapse" data-target="#report2" aria-expanded="false" aria-controls="report2">
                  <a class="fontsize16 black60 proximanova-semibold" :class="{'selectedLabel':ReportVideoProfile !== null}">Report Video Profile</a>
                </div>
                <div id="report2" class="collapse" data-parent="#accordion" aria-labelledby="cardheading2">
                  <div>
                    <div class="pl-3 pr-3 pb-3">
                      <div v-for="(reason, index) in reportProfileVideoreasonsList" :key="index">
                        <div class="d-flex mb-3" @click="clearexceptReportvideoProfile">
                          <input type="radio" :id="'reason'+reason.id" name="reportvideoprofile" :value="reason.id" class="my-auto" v-model="ReportVideoProfile">
                          <div class="d-flex flex-column">
                            <label :for="'reason'+reason.id" class="fontsize14 black proximanova-semibold labels ml-2 my-auto" :class="{'selectedLabel':ReportVideoProfile == reason.id}">{{reason.indexDetailName}}</label>
                            <!-- <span class="font12-opacity80Reg ml-2">Misleading Profile</span> -->
                          </div>
                          <br>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 reportcard1 mt-3" >
                <div class="card-header reportcard11" id="cardheading3" data-toggle="collapse" data-target="#report3" aria-expanded="false" aria-controls="report3">
                  <a class="fontsize16 black60 proximanova-semibold" :class="{'selectedLabel':ReportProfileImage !== null}">Report Profile Image</a>
                </div>
                <div id="report3" class="collapse" data-parent="#accordion" aria-labelledby="cardheading3">
                  <div>
                    <div class="pl-3 pr-3 pb-3">
                      <div v-for="(reason, index) in reportProfilePhotoreasonsList" :key="index">
                        <div class="d-flex mb-3" @click="clearexceptReportProfileImage">
                          <input type="radio" :id="'reason'+reason.id" name="reportprofileimage" :value="reason.id" class="my-auto" v-model="ReportProfileImage">
                          <div class="d-flex flex-column">
                            <label :for="'reason'+reason.id" class="fontsize14 black proximanova-semibold labels ml-2 my-auto" :class="{'selectedLabel':ReportProfileImage == reason.id}">{{reason.indexDetailName}}</label>
                            <!-- <span class="font12-opacity80Reg ml-2">Misleading Profile</span> -->
                          </div>
                          <br>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 reportcard1 mt-3" >
                <div class="card-header reportcard11" id="cardheading4" data-toggle="collapse" data-target="#report4" aria-expanded="false" aria-controls="report4">
                  <a class="fontsize16 black60 proximanova-semibold" :class="{'selectedLabel':ReportMore !== null}">Report More</a>
                </div>
                <div id="report4" class="collapse" data-parent="#accordion" aria-labelledby="cardheading4">
                  <div>
                    <div class="pl-3 pr-3 pb-3">
                      <textarea
                        class="form-control"
                        v-model="reportMessageText"
                        id="exampleFormControlTextarea1"                    
                        rows="5"
                        cols="70"
                        @keyup="addTextreport"
                        spellcheck="true"
                        maxlength="400"
                        placeholder="Repot Description (Optional)"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="mr-3 btn button-cancel1 mouseoverbtn1 borderradius20" @click="close">
            <span class="proximanova">Cancel</span>
          </button>
          <button class="mr-3 btn backgroundcolorblack white mouseoverbtn2 borderradius20 sign-up-button" @click="openConfirmmodal">
            <span class="button-create-font proximanova">Report</span>
          </button>
          </div>
      </div>
      <div class="modal-content border-0" v-if="displayConfirmationModal">
        <div class="modal-header delete-modal pb-0">
          <h5 class="modal-title fontsize18 black80 proximanova" id="deleteLikeVideoModalLabel">Are you sure you want to report on this user profile ?</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelConfirmmodal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body borderradius10 backgroundcolorwhite modal-delete text-center">
          <span class="button-cancel-font modaldeletebtn pointer border mouseoverbtn1 borderradius20 p-2 pr-4 pl-4 proximanova" @click="cancelConfirmmodal" data-dismiss="modal" aria-label="Close" >No</span>
          <button class="button-cancel-font backgroundcolorblack pointer mouseoverbtn2 white border p-1 ml-2 pr-4 pl-4 borderradius20 proximanova" :disabled="submitBtndisabled"  @click="ReportSubmit()">Yes</button>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12" v-else>
      <div class="modal-content border-0 borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
            <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
            <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
            <button class="backgroundcolor3 white mouseoverbtn2 bordernone proximanova mt-4 p-1 borderadius12" @click="close()" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default{
   data() {
    return{
      Description : '',
      videoplaying : false,
      profileId : null,
      reportMessageText: '',
      reportUser : null,
      ReportProfile : null,
      ReportVideoProfile : null,
      ReportProfileImage : null,
      ReportMore : null,
      reportProfilereasonsList : [],
      reportProfileVideoreasonsList : [],
      reportProfilePhotoreasonsList : [],
      message : '',
      displayConfirmationModal : false,
      submitBtndisabled : false,
      displayAPIerrorModal : false,
    }
  },
  props : [
      'reportuser'
  ],
  methods:{
    close() {
        this.$emit('closereport');
    },
    cancelConfirmmodal(){
      this.displayConfirmationModal = false;
      this.submitBtndisabled = false;
    },
    openConfirmmodal() {
      if(this.ReportProfile || this.ReportVideoProfile || this.ReportProfileImage || this.ReportMore) {
        this.message = ''
        this.displayConfirmationModal = true;
      }else{
        this.message = "Please select report reason before submit"
      }
    },
    // report on a user
    ReportSubmit : function() {
      console.log("report user: ", this.ReportProfile)
      console.log("report video profile : ", this.ReportVideoProfile)
      console.log("report profile image : ", this.ReportProfileImage)
      console.log("report more : ", this.reportMessageText)
      console.log("my profile id : ", this.profileId)
      console.log("user profileId : ", this.reportuser.profileId)
      this.submitBtndisabled = true;
      var vm = this;
      var rfd = new FormData();
      let obj = {
        reportByUserprofileId : this.profileId,
        reportedUserProfileId : this.reportuser.profileId,
        creationUserI : this.reportuser.currentUserEmail
      }
      if(this.ReportProfile !== null) {
        obj.reportMessageId = this.ReportProfile
      }
      if(this.ReportVideoProfile !== null) {
        obj.reportMessageId = this.ReportVideoProfile
      }
      if(this.ReportProfileImage !== null) {
        obj.reportMessageId = this.ReportProfileImage
      }
      if(this.ReportMore !== null) {
        obj.reportMessageId = this.ReportMore
        obj.description = this.reportMessageText
      }
      console.log("finali obj : ", obj)
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      rfd.append("userReport", blob)
      httpuserprofile.post("/userprofile/reportOnUser", rfd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          console.log(response)
          this.submitBtndisabled = false;
          vm.$toast.success("Reported Successfully")
          this.close()
       }).catch((e) => {
        console.log(e)
        this.submitBtndisabled = false;
        this.displayAPIerrorModal = true;
        setTimeout(() => {
            vm.close()   
        }, 5000);
      })
    },
    // user should be able to select only on report option
    // if user select tries to select multiple options the previous options should clear
    clearexceptReportProfile : function() {
      this.ReportVideoProfile = null;
      this.ReportProfileImage = null;
      this.ReportMore = null;
      this.reportMessageText = ''
    },
    clearexceptReportvideoProfile : function() {
      this.ReportProfile = null;
      this.ReportProfileImage = null;
      this.ReportMore = null;
      this.reportMessageText = ''
    },
    clearexceptReportProfileImage : function() {
      this.ReportProfile = null;
      this.ReportVideoProfile = null;
      this.ReportMore = null;
      this.reportMessageText = ''
    },
    clearexceptReportmore : function() {
      this.ReportVideoProfile = null;
      this.ReportProfileImage = null;
      this.ReportProfile = null;
    },
    addTextreport : function() {
      this.ReportMore = '114';
      this.clearexceptReportmore()
    },
    // fetching profile report reasons
    getProfileReportReasons : function() {
      httpuserprofile.get('/userprofile/getListOfAllUserProfileReportReasons')
      .then((response) => {
        console.log("profile report reasons : ", response)
        this.reportProfilereasonsList = response.data.indexDetailsList;
      }).catch((error) => {
        console.log(error)
      })
    },
    //fetching profile video report reasons
    getProfileVideoReportReasons : function() {
      httpuserprofile.get('/userprofile/getListOfAllUserProfileVideoReportReasons')
      .then((response) => {
        console.log("profile video report reasons : ", response)
        this.reportProfileVideoreasonsList = response.data.indexDetailsList;
      }).catch((e) => {
        console.log(e)
      })
    },
    //fetching profile picture report reasons
    getProfilePhotoReportReasons : function() {
      httpuserprofile.get('/userprofile/getListOfAllUserPhotoReportReasons')
      .then((response) => {
        console.log("profile photo report reassons : ", response)
        this.reportProfilePhotoreasonsList = response.data.indexDetailsList;
      }).catch((e) => {
        console.log(e)
      })
    }
  },
   mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    console.log("reportMessageBob : ", this.reportuser)
    this.getProfileReportReasons()
    this.getProfileVideoReportReasons()
    this.getProfilePhotoReportReasons()
  },

}

</script>

<style>
@import '../css/modal.css';
</style>